var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCarouselLeftNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20132_7065",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20132_7065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1641 41.1619L18.8479 29.8666C18.7206 29.7393 18.6308 29.6051 18.5785 29.4638C18.5262 29.3226 18.5 29.17 18.5 29.006C18.5 28.8421 18.5262 28.6895 18.5785 28.5483C18.6308 28.407 18.7206 28.2727 18.8479 28.1454L30.1771 16.8162C30.4335 16.5598 30.7474 16.4316 31.1188 16.4316C31.4903 16.4316 31.8155 16.5712 32.0945 16.8502C32.3649 17.1205 32.5 17.4387 32.5 17.8049C32.5 18.1712 32.3649 18.4894 32.0945 18.7597L21.8482 29.006L32.1076 39.2654C32.364 39.5218 32.4921 39.8322 32.4921 40.1967C32.4921 40.5611 32.3526 40.8829 32.0736 41.1619C31.8033 41.4322 31.4851 41.5673 31.1188 41.5673C30.7526 41.5673 30.4344 41.4322 30.1641 41.1619Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCarouselLeftNavigation);
export default __webpack_public_path__ + "static/media/ic-carousel-left-navigation.ec9d3e4359e1e7b169507880bb9ea592.svg";
export { ForwardRef as ReactComponent };